import React from "react";
import { IconOnePassDelivery, IconOnePassMembershipCard, IconOnePassRibbon, } from "@catchoftheday/cg-components";
export const BENEFITS = [
    {
        icon: (<IconOnePassMembershipCard width="28px" height="auto" title="OnePass membership card icon" aria-label="OnePass membership card icon"/>),
        description: "All current Catch and OnePass benefits, for the same price.",
    },
    {
        icon: (<IconOnePassDelivery width="28px" height="auto" title="OnePass delivery truck icon" aria-label="OnePass delivery truck icon"/>),
        description: "Free delivery on eligible items or orders* with Kmart, Target and Bunnings Warehouse",
    },
    {
        icon: (<IconOnePassRibbon width="24px" height="auto" title="OnePass ribbon icon" aria-label="OnePass ribbon icon"/>),
        description: "Personalised offers and rewards from Kmart, Target and Bunnings Warehouse",
    },
];
